import styled from 'styled-components'

export const StepContent = styled.div`
	padding-top: 4px;
`
